export default () => ({
  includes: ['user'],
  entity: 'company',
  entities: 'companies',
  companies: [],
  beenUpdated: false,
  show: false,
  company: {
    attachment: {},
    id: null,
    document: null,
    name: null,
    slug: null,
    type: null,
    contact: null,
    phone: null,
    mobile: null,
    email: null,
    bio: null
  },

  nextStepButtonIsCompanyAddresses: [
    {
      icon: '',
      text: 'Novo Local de Atendimento',
      name: 'professional.company.addresses.create',
      action: null
    }
  ],
  typeOptions: [
    {
      id: 'clinic',
      label: 'Clínica Médica'
    },
    {
      id: 'office',
      label: 'Consultório Médico'
    },
    {
      id: 'hospital',
      label: 'Hospital'
    },
    {
      id: 'laboratory',
      label: 'Laboratório'
    },
    {
      id: 'others',
      label: 'Outros'
    }
  ],
  // never use prefix v1.
  prefixRouter: 'professional.companies'

})



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/resources/data.js